import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/core/Link';
import { H3, H4, Paragraph } from 'components/core/Typography';
import { Section } from 'components/core/Page';
import { LandingSection } from 'components/landing/LandingSection';

export default function MovingTruckBlogContent({ city }) {
	let title = 'moving truck resources';
	title = city ? `${city} ${title}` : title;
	return (
		<div>
			<LandingSection>
				<Section>
					<H3 size="large">
						{ title }
					</H3>
				</Section>
				<H4 size="medium">
					6 Things you should never pack in a moving truck
				</H4>
				<Paragraph>
					There’s no question that packing to move typically takes longer than you expect.
					And at that 11th hour, it can be tempting to just throw everything that’s left
					in a box for the moving company or on the truck. Not so fast. There are a number
					of common household items that cannot go on a moving truck.
				</Paragraph>
				<Link
					href="blog/19750-6-things-you-should-never-pack-in-a-moving-truck/"
					target="_blank"
					rel="noreferrer noopener"
				>
					Read More
				</Link>
			</LandingSection>
			<LandingSection>
				<H4 size="medium">
					The Rules of the Road for Borrowing a Truck for a Move
				</H4>
				<Paragraph>
					If you’re planning to move large items like furniture and collectible art, whether to a new
					home or a storage space, you’ll likely need to use a pickup truck, van or full-size truck.
					If you don’t want to hire professional movers or rent a moving truck, you might wind up
					borrowing a pickup truck from a relative or friend.
				</Paragraph>
				<Link
					href="/moving/moving-resources/4384067-the-rules-of-the-road-for-borrowing-a-pickup-truck-for-a-move/"
					target="_blank"
					rel="noreferrer noopener"
				>
					Read More
				</Link>
			</LandingSection>
			<LandingSection>
				<H4 size="medium">
					5 Tips on How to Rent a Moving Truck
				</H4>
				<Paragraph>
					When you need to transport a lot of possessions to a self-storage unit or to a new home,
					hiring movers to do the job can be expensive. In fact, according to the American Moving &
					Storage Association, the average professional moving job within the same state costs about
					$1,170.
				</Paragraph>
				<Link
					href="/blog/4384111-5-tips-on-how-to-rent-a-moving-truck/ "
					target="_blank"
					rel="noreferrer noopener"
				>
					Read More
				</Link>
			</LandingSection>
			<LandingSection>
				<H4
					size="medium"
				>
					What you need to know about moving truck insurance before you rent
				</H4>
				<Paragraph>
					Clark Allen opted to buy the insurance when he rented a medium-sized moving truck to help his
					girlfriend move from Cambridge to a Boston suburb, and is sure glad he did.
				</Paragraph>
				<Link
					href="/blog/17683-moving-truck-insurance/"
					target="_blank"
					rel="noreferrer noopener"
				>
					Read More
				</Link>
			</LandingSection>
		</div>
	);
}

MovingTruckBlogContent.propTypes = {
	city: PropTypes.string
};
